// Check if script is already loaded
if (!window.yswProductInitialized) {
  window.yswProductInitialized = true;

const initOption = () => {
  setTimeout(selectRadioInputs, 2000);
}

const selectRadioInputs = () => {
  const radioInputsList = document.querySelectorAll('.product-main input[type="radio"]');

  if (radioInputsList && radioInputsList.length > 0) {
    const arrayFromRadioInputsList = Array.from(radioInputsList);

    arrayFromRadioInputsList.forEach(radio => {
      radio.addEventListener("click", handleClick);
    });
  }
}

function handleClick() {
  const productMain = document.querySelector(".product-main");
  const productCurrentPriceMax = productMain.querySelector(".price__current--max");
  const productComparePriceMax = productMain.querySelector(".price__compare-at--max");
  const spacerElements = productMain.querySelectorAll(".spacer");

  const isNull = !productMain || !productCurrentPriceMax || !productComparePriceMax || !spacerElements;

  if (!isNull && this.value === "Yes") {
    removeElement(productCurrentPriceMax);
    removeElement(productComparePriceMax);
    spacerElements.forEach(removeElement);
  }
}

const removeElement = (element) =>  element && element.remove();

document.addEventListener('DOMContentLoaded', initOption);

  // Tab functionality
  (function () {
    let isInitialized = false;
    const ANIMATION_SPEED = 800;
    const MOBILE_BREAKPOINT = 768;

    // Shared state
    let isScrolling = false;
    let lastWidth = window.innerWidth;
    let resizeTimer;

    function checkJQuery() {
      if (window.jQuery) {
        initializeWithJQuery(jQuery);
      } else {
        setTimeout(checkJQuery, 100);
      }
    }

    function initializeWithJQuery($) {
      // Watch for modal loaded state
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          // Check if the modal is loaded and visible
          if (mutation.target.classList && 
              mutation.target.classList.contains('modal-loaded') && 
              mutation.target.classList.contains('modal-visible')) {
            
            // Create a new observer for modal content changes
            const contentObserver = new MutationObserver(function(contentMutations) {
              // Check if we have product details
              const $productDetails = $('.modal-content [data-product-details]');
              
              if ($productDetails.length > 0) {
                // Check if tabs are already initialized
                if ($productDetails.find('.tab-indicator').length > 0) {
                  contentObserver.disconnect();
                  return;
                }
                
                // Disconnect observer before making DOM changes
                contentObserver.disconnect();
                setupMobileTabs($productDetails);
              }
            });
            
            // Observe changes to the modal content
            const modalContent = document.querySelector('.modal-content');
            if (modalContent) {
              contentObserver.observe(modalContent, {
                childList: true,
                subtree: true
              });
            }
          }
        });
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });

      function getPageVersion() {
        const $modal = $('[data-product-details]');
        const isInModal = $modal.find('h2.title').length > 0;
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

        return {
          isModal: isInModal,
          isMobile: isMobile,
          isDesktop: !isMobile && !isInModal,
          windowWidth: window.innerWidth,
        };
      }

      function initializeReadMore($container) {
        const $overviewTab = $container.find('h2.title:contains("Overview")').next('.tab-content-wrapper');
        const $paragraphs = $overviewTab.find('p:not(:contains("* Add 2"))');

        if ($paragraphs.length > 1 && $overviewTab.find('.read-more-link').length === 0) {
            const $readMoreLink = $('<a class="read-more-link">')
            .html('<span>Read More</span> ▼')
            .click(function(e) {
                    e.preventDefault();
              e.stopPropagation();
              const $wrapper = $(this).closest('.tab-content-wrapper');
              $wrapper.toggleClass('expanded');
              $(this).html($wrapper.hasClass('expanded') ? '<span>Read Less</span> ▲' : '<span>Read More</span> ▼');
              return false;
                });

            $paragraphs.eq(0).after($readMoreLink);
        }
      }

      function initializeHeaders($headers) {
        // Reset all tabs to collapsed state
        $headers.each(function () {
          const $header = $(this);
          const $content = $header.next('.tab-content-wrapper');
          $header.addClass('collapsed').removeClass('expanded');
          $content.hide();
        });

        // Add click handlers
        $headers.off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const $header = $(this);
          const $content = $header.next('.tab-content-wrapper');
          const wasExpanded = $header.hasClass('expanded');

          // Close all tabs
          $headers.each(function () {
            const $h = $(this);
            $h.addClass('collapsed').removeClass('expanded');
            $h.next('.tab-content-wrapper').slideUp(ANIMATION_SPEED);
          });

          // If this wasn't expanded, expand it
          if (!wasExpanded) {
            $header.removeClass('collapsed').addClass('expanded');
            $content.slideDown(ANIMATION_SPEED);
          }
        });

        // Set initial state for first tab
        const $firstHeader = $headers.first();
        $firstHeader.removeClass('collapsed').addClass('expanded');
        $firstHeader.next('.tab-content-wrapper').show();
      }

      function setupMobileTabs($container) {
        // Clean up existing handlers and classes
        $container.find('h2.title').off('click');
        $container.find('.active').removeClass('active');

        // Initialize tabs
        const $headers = $container.find('h2.title');
        
        // First ensure all tabs are in initial state and add indicators
        $headers.each(function(index) {
          const $header = $(this);
          const $content = $header.next('.tab-content-wrapper');
          
          // Check for existing indicator
          const $existingIndicator = $header.find('.tab-indicator');
          if ($existingIndicator.length > 0) {
            // Update existing indicator
            $existingIndicator.text(index === 0 ? '-' : '+');
          } else {
            // Add new indicator
            $header.append('<span class="tab-indicator">' + (index === 0 ? '-' : '+') + '</span>');
          }
          
          if (index === 0) {
            // Set first tab as active
            $header.addClass('active');
            $content.addClass('active');
          } else {
            // Reset state for other tabs
            $content.removeClass('active');
            $header.removeClass('active');
          }
        });
        
        // Then set up click handlers
        $headers.each(function() {
            const $header = $(this);
            
          $header.off('click').on('click', function(e) {
                if (e.target === this || $(e.target).hasClass('tab-indicator')) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (!isScrolling) {
                const $content = $(this).next('.tab-content-wrapper');
                const $indicator = $(this).find('.tab-indicator');
                
                        $(this).toggleClass('active');
                        $content.toggleClass('active');
                        $indicator.text($(this).hasClass('active') ? '-' : '+');
                    }
                }
            });
        });

        // Initialize read more functionality
        initializeReadMore($container);
      }

      function initializePage() {
        const $modal = $('[data-product-details]');
        const $productDescription = $('.product-block--description');
        const pageVersion = getPageVersion();
        const $container = pageVersion.isModal ? $modal : $productDescription;

        if (pageVersion.isDesktop) {
          initializeReadMore($container);
        } else {
          setupMobileTabs($container);
        }
      }

      // Initialize when document is ready
      $(document).ready(function () {
        initializePage();

        // Handle scroll state
        $(window).on('scroll', function() {
            isScrolling = true;
            clearTimeout($.data(this, 'scrollTimer'));
            $.data(this, 'scrollTimer', setTimeout(function() {
                isScrolling = false;
            }, 250));
        });

        // Handle resize
        $(window).on('resize', function () {
          if (isScrolling) return;
            
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                const newWidth = window.innerWidth;
                if (newWidth !== lastWidth) {
                    lastWidth = newWidth;
                    initializePage();
                }
            }, 250);
        });
      });
    }

    // Start checking for jQuery
    checkJQuery();
  })();
}
